var _path, _rect, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScissorsLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46998 5.63211V8.18149H15.2493V5.63211L2.46998 5.63211ZM2.46998 4.33211H15.2493V1.3H2.46998V4.33211ZM16.5493 5.63211V8.18149H21.5305V5.63211H16.5493ZM21.5305 4.33211H16.5493V1.3H21.5305V4.33211ZM15.2493 9.48149H16.5493H21.8305C22.3827 9.48149 22.8305 9.03377 22.8305 8.48149V1C22.8305 0.447715 22.3827 0 21.8305 0H16.5493H15.2493H2.16998C1.6177 0 1.16998 0.447716 1.16998 1V8.48149C1.16998 9.03377 1.6177 9.48149 2.16998 9.48149H15.2493Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.0849,
    height: 6.0849,
    transform: "matrix(0.820709 -0.571347 0.820709 0.571347 6.58508 12.7735)",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.0849,
    height: 6.0849,
    transform: "matrix(0.820709 -0.571347 0.820709 0.571347 6.58508 19.4193)",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16998 23H19.17",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissorsLift);
export default __webpack_public_path__ + "static/media/scissors-lift.a2cc8664cd8566dec8780d85fb327a0e.svg";
export { ForwardRef as ReactComponent };